import { VERIFY_PAYMENT } from "../../../../../constants";
import { apiSlice } from "./apiSlice";

export const paymentApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      verifyPayment: builder.mutation({
        query: ({ data, token }) => {
          return {
            url: VERIFY_PAYMENT,
            method: "POST",
            body: data,
            headers: {
                Authorization: token ? `Bearer ${token}` : '', 
            },
          };
        },
      }),
    }),
  });
  

export const { useVerifyPaymentMutation } = paymentApiSlice;
